import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { useAuth } from "@/features/auth";

const Component = () => {
  const { user } = useAuth();

  if (user?.current_user_id) {
    return <Navigate to="/consent-solutions" />;
  }

  return <Outlet />;
};

const Route = createFileRoute("/_public")({
  component: () => <Component />,
});

export { Route };
